import { CarouselRail } from '~/components-v2/carousel-rail/carousel-rail'
import type { PostSummary } from '~/types'
import { PostCard, type VideoPost } from './post-card'
import type { LinksFunction } from 'react-router'
import type { ReactNode } from 'react'
import post from './post.css?url'
import clsx from 'clsx'

export const postCollectionLinks: LinksFunction = () => [
  { rel: 'stylesheet', href: post },
]

type PostCollectionProps = {
  header?: ReactNode
  postBasePath?: '/articles' | '/blog'
  posts: ((PostSummary & { isVideo?: boolean }) | VideoPost)[]
  variant?: 'grid' | 'carousel' | 'blog-grid'
}

export const PostCollection = ({
  header,
  postBasePath = '/blog',
  posts,
  variant = 'grid',
}: PostCollectionProps) => {
  const isCarousel = variant === 'carousel'
  const visiblePosts = isCarousel ? posts.slice(0, 6) : posts

  if (visiblePosts.length === 0) {
    return (
      <div className={clsx('post-collection', `post-collection--${variant}`)}>
        <p>No posts found.</p>
      </div>
    )
  }

  if (isCarousel) {
    return (
      <CarouselRail
        className="post-collection post-collection--carousel"
        desktopEndSpacerSlides={2}
        desktopVisibleSlides={3}
        header={header}
        viewAll={{ href: '/blog', label: 'View All' }}
        viewportControls={Boolean(header)}
      >
        {visiblePosts.map((post) => (
          <PostCard
            key={'href' in post ? post.href : post.slug}
            {...post}
            postBasePath={postBasePath}
            variant="carousel"
          />
        ))}
      </CarouselRail>
    )
  }

  return (
    <div className={clsx('post-collection', `post-collection--${variant}`)}>
      {visiblePosts.map((post) => (
        <PostCard
          key={'href' in post ? post.href : post.slug}
          {...post}
          postBasePath={postBasePath}
          variant={variant === 'blog-grid' ? 'blog-grid' : 'default'}
        />
      ))}
    </div>
  )
}
